import React from "react";
import { NavLink } from "react-router";

type LinkProps = {
  to: string;
  onClick?: () => void;
  title?: string;
  "aria-label"?: string;
  children?: React.ReactNode;
  className?: string | (({ isActive }: { isActive: boolean }) => string);
};

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & { to?: undefined };

type NavButtonProps = LinkProps | ButtonProps;

const baseClasses = "text-white hover:underline focus:ring focus:outline-none px-2 py-1";

const NavButton: React.FC<NavButtonProps> = (props) => {
  if (props.to !== undefined) {
    const { to, onClick, title, children, className, "aria-label": ariaLabel } = props as LinkProps;
    const resolvedClass =
      typeof className === "function"
        ? className
        : ({ isActive }: { isActive: boolean }) =>
            `${baseClasses}${className ? ` ${className}` : ""}${isActive ? " active-nav" : ""}`;
    return (
      <NavLink to={to} onClick={onClick} title={title} aria-label={ariaLabel} className={resolvedClass}>
        {children}
      </NavLink>
    );
  }

  const { children, className, ...rest } = props as ButtonProps;
  return (
    <button className={className ? `${baseClasses} ${className}` : baseClasses} type="button" {...rest}>
      {children}
    </button>
  );
};

export default NavButton;
